import { render, staticRenderFns } from "./ProcessoResumoIA.vue?vue&type=template&id=4036e12c&scoped=true&"
import script from "./ProcessoResumoIA.vue?vue&type=script&lang=js&"
export * from "./ProcessoResumoIA.vue?vue&type=script&lang=js&"
import style0 from "./playground.styl?vue&type=style&index=0&id=4036e12c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4036e12c",
  null
  
)

export default component.exports